import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input
} from '@angular/core';
import { LoaderType } from '@helpers/html/loader-type';
import { SkeletonModule } from 'primeng/skeleton';

/**
 * Componente que muestra un loader para expresar que se está cargando información.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-loader',
  imports: [SkeletonModule],
  template: `
    @switch (type()) {
      @case ('skeleton') {
        @for (item of items(); track $index) {
          <div class="mt-4">
            <p-skeleton />
          </div>
        }
      }
    }
  `,
  styles: ``
})
export class AppLoaderComponent {
  /**
   * Tipo de loader a mostrar.
   */
  type = input.required<LoaderType>();

  /**
   * Cantidad de loaders a mostrar del tipo seleccionado.
   */
  count = input<number>(1);

  /**
   * Obtiene un array con la cantidad de loaders a mostrar para recorrerlos en el template.
   */
  items = computed(() => Array.from({ length: this.count() }));
}
